import BaseStructure from 'components/BaseStructure';
import { IBaseStructureProps } from 'components/BaseStructure/types';
import { useRoutesDisplayValues } from 'hooks/useRoutesDisplayValues';
import React from 'react';
import ROUTES from 'routes/routeConstants';

const AccountingPageContainer: React.FC<IBaseStructureProps> = ({ children, ...props }) => {
  const routeDisplayValue = useRoutesDisplayValues()[ROUTES.ACCOUNTINGS];
  return (
    <BaseStructure
      mobileThreshold={575}
      header={routeDisplayValue.text}
      headerIconName={routeDisplayValue.iconClass}
      {...props}>
      <div className='accounting-page-container'>{children}</div>
    </BaseStructure>
  );
};

export default React.memo(AccountingPageContainer);
